import { Map, List } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_FETCH_ARTICLES,
	FETCH_ARTICLES_SUCCESS,
	FETCH_ARTICLES_FAILED,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	data: List(),

	loadingStatus: NONE,
	loadingStatusMessage: '',
});

export default function article(state = initialState, action) {
	switch (action.type) {
		case START_FETCH_ARTICLES:
			return state
				.set('loadingStatus', LOADING)
				.set('loadingStatus', NONE);

		case FETCH_ARTICLES_SUCCESS:
			return state
				.set('data', List(action.articles))
				.set('loadingStatus', SUCCESS);

		case FETCH_ARTICLES_FAILED:
			return state
				.set('loadingStatus', FAILED)
				.set('loadingStatusMessage', action.errorMessage);

		default:
			return state;
	}
}
